<template>
  <Wrapper>
    <component-guard :requiredPermissions="['27.1']">
      <div class="lessee-adjustment-container">
        <div class="content">
          <!-- Filter Section -->
          <div class="filter-box">
            <div class="filter-content">
              <div class="filter-grid">
                <div class="form-group">
                  <label>ID / Order ID</label>
                  <input
                    v-model="filters.orderId"
                    type="text"
                    placeholder="ID / Order ID"
                    class="form-input"
                  />
                </div>

                <div class="form-group">
                  <label>Kode Produk</label>
                  <input
                    v-model="filters.productCode"
                    type="text"
                    placeholder="Kode Produk"
                    class="form-input"
                  />
                </div>

                <div class="form-group">
                  <label>Lessee Awal</label>
                  <input
                    v-model="filters.firstLessee"
                    type="text"
                    placeholder="Lessee Awal"
                    class="form-input"
                  />
                </div>

                <div class="form-group">
                  <label>Lessee Target</label>
                  <input
                    v-model="filters.targetLessee"
                    type="text"
                    placeholder="Lessee Target"
                    class="form-input"
                  />
                </div>

                <input-date
                  label="Tanggal Efektif (from)"
                  v-model="filters.dateEfectiveFrom"
                  type="date"
                  placeholder="dd/mm/yyyy"
                  @change="handleChangeFilter('dateEfectiveFrom', $event)"
                />

                <input-date
                  label="Tanggal Efektif (to)"
                  v-model="filters.dateEfectiveTo"
                  type="date"
                  placeholder="dd/mm/yyyy"
                  @change="handleChangeFilter('dateEfectiveTo', $event)"
                />

                <single-select
                  id="type-status"
                  :value="filters.status"
                  @change="handleChangeFilter('status', $event)"
                  :options="[
                    { label: 'Draft', value: 'draft' },
                    { label: 'Dalam Verifikasi', value: 'verification' },
                    { label: 'Dibatalkan', value: 'cancelled' },
                    { label: 'Selesai', value: 'executed' },
                    { label: 'Siap Dialihkan', value: 'ready' },
                    { label: 'Gagal Dialihkan', value: 'failed' },
                    { label: 'Sedang Dialihkan', value: 'processing' },
                  ]"
                  placeholder="Pilih Status"
                  label="Status"
                  :customClass="{ labelClass: 'm-0' }"
                />

                <single-select
                  id="type-select"
                  :value="filters.leaseType"
                  @change="handleChangeFilter('leaseType', $event)"
                  :options="[
                    { label: 'Pengalihan Unit', value: 'pengalihan unit' },
                    { label: 'Perubahan Nama', value: 'perubahan nama' },
                  ]"
                  placeholder="Pilih Tipe"
                  label="Tipe"
                  :customClass="{ labelClass: 'm-0' }"
                />
              </div>
            </div>
            <div class="filter-actions">
              <button class="btn btn-primary" @click="handleSearch">
                Cari
              </button>
              <button class="btn btn-secondary" @click="handleReset">
                Reset
              </button>
            </div>
          </div>

          <!-- Create Button -->
          <type-prompt />

          <!-- Data Table -->
          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <!-- <th>TIPE</th> -->
                  <th>LESSEE AWAL</th>
                  <th>LESSEE TARGET</th>
                  <th>TANGGAL EFEKTIF</th>
                  <th>TIPE PEMBARUAN</th>
                  <th>STATUS</th>
                </tr>
              </thead>
              <tbody>
                <!-- loading state -->
                <tr v-if="isLoading">
                  <td colspan="6">
                    <img src="~@/assets/images/load-button.gif" />
                  </td>
                </tr>
                <tr v-for="row in tableData" :key="row.id">
                  <td class="id-column">
                    <div @click="resetFormState">
                      <component-guard :requiredPermissions="['28.1']">
                        <div @click="resetFormState">
                          <router-link
                            :to="`/rent-adjustment/${row.ltId}?${
                              row.ltStatus !== 'draft' ? 'tab=verification' : ''
                            }`"
                            >{{ row.ltCode }}</router-link
                          >
                        </div>
                        <template slot="replacement">
                          <span>{{ row.ltCode }}</span>
                        </template>
                      </component-guard>
                    </div>
                  </td>
                  <td>{{ row.lesseeAwal }}</td>
                  <td>{{ row.lesseeTarget }}</td>
                  <td>{{ formatDate(row.effectiveDate) }}</td>
                  <td class="type-column">
                    <StatusBadge
                      :statusText="row.type"
                      :statusClass="row.typeClass"
                    />
                  </td>
                  <td>
                    <StatusBadge
                      :statusText="row.status"
                      :statusClass="row.statusClass"
                    />
                  </td>
                </tr>
                <!-- Not found data state -->
                <tr v-if="!isLoading && tableData.length === 0">
                  <td colspan="6" class="text-center">
                    Tidak ada data yang tersedia.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="pagination-section">
            <div class="pagination-info">
              <select v-model="itemPerPage" class="page-select">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span class="total-data">Total Data {{ totalData }}</span>
            </div>
            <div class="pagination-controls">
              <button
                @click="prevPage"
                class="btn-pagination"
                :class="[{ disabled: isPrevPageBtnDisabled }]"
              >
                <i class="fa fa-chevron-left"></i>
              </button>
              <span class="page-indicator"
                >{{ page }} of {{ totalPage }} page</span
              >
              <button
                @click="nextPage"
                class="btn-pagination"
                :class="[{ disabled: isNextPageBtnDisabled }]"
              >
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </component-guard>
  </Wrapper>
</template>

<script>
import { Wrapper } from "../Layout";
import StatusBadge from "./CustomComponent/StatusBadge.vue";
import { SingleSelect, InputDate } from "../Input";
import { ComponentGuard, permissionMixin } from "../Permissions";
import { mapActions } from "vuex";
import TypePrompt from "./CustomComponent/TypePrompt.vue";

export default {
  name: "ListRentAdjustment",
  components: {
    Wrapper,
    StatusBadge,
    SingleSelect,
    ComponentGuard,
    InputDate,
    TypePrompt,
  },
  mixins: [permissionMixin],
  data() {
    return {
      filters: {
        orderId: this.$route.query.orderId || "",
        productCode: this.$route.query.productCode || "",
        leaseType: this.$route.query.leaseType || "",
        status: this.$route.query.status || "",
        firstLessee: this.$route.query.firstLessee || "",
        targetLessee: this.$route.query.targetLessee || "",
        dateEfectiveTo: this.$route.query.dateTo || "",
        dateEfectiveFrom: this.$route.query.dateFrom || "",
      },
      page: this.$route.query.page || "1",
      itemPerPage: this.$route.query.itemPerPage || "10",
      totalData: 0,
      totalPage: 0,
      tableData: [],
      isLoading: false,
    };
  },
  computed: {
    isNextPageBtnDisabled() {
      return this.page >= this.totalPage;
    },
    isPrevPageBtnDisabled() {
      return this.page <= 1;
    },
  },
  methods: {
    ...mapActions("rentAdjustment", [
      "getListRentAdjustment",
      "resetFormState",
    ]),
    handleChangeFilter(key, value) {
      this.filters[key] = value;
    },
    handleChangePagination(key, value) {
      if (key === "itemPerPage") {
        this.itemPerPage = value;
      } else if (key === "page") {
        this.page = value;
      }
    },
    async triggerFetchData() {
      this.$router.replace({
        query: {
          orderId: this.filters.orderId || "",
          productCode: this.filters.productCode || "",
          leaseType: this.filters.leaseType || "",
          status: this.filters.status || "",
          firstLessee: this.filters.firstLessee || "",
          targetLessee: this.filters.targetLessee || "",
          dateFrom: this.filters.dateEfectiveFrom || "",
          dateTo: this.filters.dateEfectiveTo || "",
          itemPerPage: this.itemPerPage || "10",
          page: this.page || "1",
        },
      });
      this.fetchData();
    },
    async fetchData() {
      this.isLoading = true;
      this.tableData = [];
      try {
        const response = await this.getListRentAdjustment({
          ...this.filters,
          page: Number(this.page),
          itemPerPage: Number(this.itemPerPage),
        });
        this.tableData = response.data.map((item) => {
          const statusClassMapping = {
            draft: "black",
            verification: "yellow",
            cancelled: "black",
            executed: "green",
            ready: "blue",
            failed: "red",
            processing: "orange",
          };
          const statusTextMapping = {
            draft: "Draft",
            verification: "Dalam Verifikasi",
            cancelled: "Dibatalkan",
            executed: "Selesai",
            ready: "Siap Dialihkan",
            failed: "Gagal Dialihkan",
            processing: "Sedang Dialihkan",
          };
          const typeMapping = {
            "pengalihan unit": "Pengalihan Unit",
            "perubahan nama": "Perubahan Nama",
          };
          const typeClassMapping = {
            "pengalihan unit": "purple",
            "perubahan nama": "violet",
          };
          return {
            ...item,
            statusClass: statusClassMapping[item.ltStatus],
            status: statusTextMapping[item.ltStatus],
            type: typeMapping[item.leaseType],
            typeClass: typeClassMapping[item.leaseType],
          };
        });
        this.totalData = response.totalData;
        this.totalPage = response.totalPage;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleSearch() {
      this.page = 1;
      this.triggerFetchData();
    },
    handleReset() {
      this.filters = {
        orderId: "",
        productCode: "",
        type: "",
        status: "",
        firstLessee: "",
        targetLessee: "",
        status: "",
        dateEfectiveTo: "",
        dateEfectiveFrom: "",
      };
      this.itemPerPage = 10;
      this.page = 1;
      this.triggerFetchData();
    },
    handleCreate() {
      this.resetFormState();
      this.$router.push({
        path: "/rent-adjustment/create",
      });
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },

    nextPage() {
      if (this.isNextPageBtnDisabled) return;
      this.page = Number(this.page) + 1;
      this.triggerFetchData();
    },
    prevPage() {
      if (this.isPrevPageBtnDisabled) return;
      this.page = Number(this.page) - 1;
      this.triggerFetchData();
    },
  },
  watch: {
    itemPerPage() {
      this.page = 1;
      this.triggerFetchData();
    },
  },
  mounted() {
    if (
      this.hasPermission({
        requiredPermissions: ["27.1"],
        redirectUrl: "/home",
      })
    ) {
      this.fetchData();
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.lessee-adjustment-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #ffffff;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px 32px;
  overflow-y: auto;
}

.filter-box {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background-color: #ffffff;
  border: 1px solid #d1d9e2;
  border-radius: 8px;
}

.filter-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.filter-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #2e3646;
  line-height: 20px;
}

.form-input {
  height: 40px;
  padding: 0 16px;
  border: 1px solid #d1d9e2;
  border-radius: 6px;
  font-size: 14px;
  color: #2e3646;
  background-color: #ffffff;
  width: 100%;
}

.form-input::placeholder {
  color: rgba(109, 120, 141, 0.5);
}

.date-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.date-input-wrapper input {
  padding-right: 10px;
  width: 100%;
}

.date-input-wrapper i {
  position: absolute;
  right: 16px;
  color: #6d788d;
  pointer-events: none;
}

.filter-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: end;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 40px;
}

.btn-primary {
  background-color: #247fec;
  color: #ffffff;
}

.btn-primary:hover {
  background-color: #1a5db8;
}

.btn-secondary {
  background-color: #ffffff;
  color: #2e3646;
  border: 1px solid #d1d9e2;
}

.btn-secondary:hover {
  background-color: #f8f9fa;
}

.table-container {
  background-color: #ffffff;
  border: 1px solid #d1d9e2;
  border-radius: 8px;
  overflow: hidden;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.data-table thead {
  background-color: #f8f9fa;
  border-bottom: 1px solid #d1d9e2;
}

.data-table thead th:nth-child(2) {
  width: 30%;
}

.data-table th {
  padding: 10px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #6a7282;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-right: 1px solid #d1d9e2;
}

.data-table th:last-child {
  border-right: none;
}

.data-table tbody tr {
  border-bottom: 1px solid #d1d9e2;
}

.data-table tbody tr:last-child {
  border-bottom: none;
}

.data-table td {
  padding: 10px;
  text-align: center;
  color: #2e3646;
  border-right: 1px solid #d1d9e2;
}

.data-table td:last-child {
  border-right: none;
}

.id-column {
  color: #247fec !important;
  text-transform: uppercase;
  font-weight: 500;
  text-align: center;
  width: 100px;
}

.type-column {
  width: 180px;
}

.chips-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.chip {
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  display: inline-block;
  width: fit-content;
}

.chip-green {
  background-color: #13734b;
}

.chip-purple {
  background-color: #5b3286;
}

.pagination-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.pagination-info {
  display: flex;
  gap: 10px;
  align-items: center;
  flex: 1;
}

.w-40 {
  width: 100px !important;
}

.page-select {
  height: 32px;
  padding: 0 16px;
  border: 1px solid #d1d9e2;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 16px;
  color: #2e3646;
  cursor: pointer;
  font-weight: 500;
  border-radius: 10px;
}

.total-data {
  font-size: 16px;
  color: #000000;
  font-weight: 400;
}

.pagination-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.page-indicator {
  background-color: #3098f7;
  color: #ffffff;
  padding: 4px 20px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 10px;
  box-shadow: 0 1 2 -1 rgba(0, 0, 0, 0.1), 0 1 3 0 rgba(0, 0, 0, 0.1);
}

.btn-pagination {
  width: auto;
  padding: 4px 20px;
  border: 1px solid #247fec;
  background-color: #f8fafc;
  color: #247fec;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
  height: fit-content !important;
  outline: none !important;
}

.btn-pagination.disabled {
  width: auto;
  padding: 4px 20px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  color: #e2e8f0;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
  height: fit-content !important;
  outline: none !important;
}

.btn-pagination:hover {
  background-color: #f0f7ff;
}

/* Responsive Design */
@media (max-width: 768px) {
  .filter-grid {
    grid-template-columns: 1fr;
  }

  .filter-actions {
    justify-content: flex-end;
  }

  .data-table {
    font-size: 12px;
  }

  .data-table th,
  .data-table td {
    padding: 8px 5px;
  }

  .id-column {
    width: 60px;
  }

  .type-column {
    width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RentAdjustment/ListRentAdjustment.vue